
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import Utils from "@/utilities/Utils";
    import { WorkPermitPerson } from "@/model/workPermits/WorkPermitPerson";

    @Component({ components: { PrimaryButton } })
    export default class WorkPermitPersonPicker extends Vue {

        @Prop({ required: true }) personList!: Array<WorkPermitPerson>;
        @Prop({ required: true }) siteID!: string;
        // @Prop({ required: true }) isPendingVisits!: boolean;
        // @Prop({ required: true }) searchText!: string;

        showDialogue: boolean = false;

        adHocName: string = "";
        adHocEmail: string = "";

        today = new Date(new Date().setHours(0, 0, 0, 0));
        isPendingVisits: boolean = true;
        filterText: string = "";

        get isAdHocNameToAdd(): boolean { return !Utils.isEmptyOrWhitespace(this.adHocName); }

        addAdHoc(): void {
            this.$emit("add-person", this.adHocName, this.adHocEmail);
            this.hide();
        }

        show(): void {
            this.showDialogue = true;
        }

        hide(): void {
            this.adHocName = "";
            this.adHocEmail = "";
            this.showDialogue = false;
        }

        get isASiteID(): boolean { return !Utils.isEmptyId(this.siteID); }

        get personListFiltered(): Array<WorkPermitPerson> {
            return this.personList.filter(p =>
                (!this.isPendingVisits || p.plannedArrival >= this.today) &&
                (Utils.isEmptyOrWhitespace(this.filterText) || p.name.toLowerCase().includes(this.filterText.toLowerCase()))
            );
        }

        togglePerson (person: WorkPermitPerson) {
            person.isSelected = !person.isSelected;
            this.$emit("toggle-person", person);
        }

        @Watch("personList", { deep: true, immediate: false })
        onPersonListChanged() {
            this.$emit("changed", this.personList);
        }
    }
